module.exports = __webpack_public_path__ + "static/img/about-me-detail.849839f2.jpg";